import React from 'react'
import PropTypes from 'prop-types'
import { FocusHeader } from '@olxbr/ds-web'
import styled from 'styled-components'
import { HiddenIn } from '../../atoms/HiddenIn'
import { FeedbackApproved } from '../../atoms/FeedbackApproved'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 492px;
`

const Description = styled.span.attrs({ className: 'typo-body-medium' })`
  white-space: pre-line;
`

const ContentWrapper = styled.section`
  max-width: calc(1224px + (var(--spacing-4) * 2));
  padding: var(--spacing-10) var(--spacing-4);
  flex: 1;
`

const ChangeInfoSuccessTemplate = ({ title, description, children, hideHeader }) => {
  return (
    <>
      {!hideHeader && <FocusHeader />}
      <div className="flex justify-center">
        <ContentWrapper>
          <div className="flex justify-between">
            <Content>
              <span className="typo-title-large mt-4 mb-2">{title}</span>
              <Description className="mb-4 text-neutral-110">{description}</Description>
              <div className="flex justify-center">{children}</div>
            </Content>
            <div className="flex items-center">
              <HiddenIn tablet mobile>
                <FeedbackApproved />
              </HiddenIn>
            </div>
          </div>
        </ContentWrapper>
      </div>
    </>
  )
}

ChangeInfoSuccessTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOf([PropTypes.node, PropTypes.string]),
}

export { ChangeInfoSuccessTemplate }
